export const RESET_PUBLIC_SCORING = 'RESET_PUBLIC_SCORING';
export const CLEAR_PUBLIC_SCORING_RESET = 'CLEAR_PUBLIC_SCORING_RESET';
export const SET_PUBLIC_SCORING = 'SET_PUBLIC_SCORING';
export const SET_IS_PUBLIC_SCORESHEET_EDITED = 'SET_IS_PUBLIC_SCORESHEET_EDITED';
